/** @format */

import React, { PureComponent } from 'react';
import I18n from '../../../components/Translate/I18n';
import { Typography } from '@material-ui/core';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import withStyles from '@material-ui/core/styles/withStyles';
import compose from 'recompose/compose';
import Card from '@material-ui/core/Card';
import CardHeader from '../../../components/Card/CardHeader';
import CardBody from '../../../components/Card/CardBody';
import Table from '@material-ui/core/Table';
import { BlockContainHelper, GetContainViewProps } from '../../../modules/block/BlockContainHelper';
import { SleepTimeElement } from '../SleepTimeElement';
import TableHead from '@material-ui/core/TableHead';
import { ErrorElement } from '../ErrorElement';
import { CallFunctionElement } from '../CallFunctionElement';
import { DefinitionHeaderElement } from '../DefinitionHeaderElement';
import { CallBlockElement } from '../CallBlockElement';
import TableBody from '@material-ui/core/TableBody';
import { StatusElement } from '../StatusElement';

class DefaultView extends PureComponent<GetContainViewProps> {
    private blockHelper = new BlockContainHelper();

    render(): React.ReactNode {
        const { element, functions } = this.props;

        const functionName = 'prov:f.' + element.mvnoBlockFunction.displayName.trim().toLowerCase();
        const params = this.blockHelper.explodeParams(element);

        return (
            <Card>
                <CardHeader>
                    <Typography variant="subtitle1">
                        <I18n trans={functionName} />
                    </Typography>
                </CardHeader>
                <CardBody xs={12}>
                    <SleepTimeElement seconds={element.sleepSeconds} />
                    <Table>
                        <TableHead>
                            <DefinitionHeaderElement />
                        </TableHead>
                        <TableBody>
                            {params.callBlock && <CallBlockElement name={params.callBlock.blockId} params={null} />}
                            {params.callNext && (
                                <CallFunctionElement
                                    name="prov:f.get_ok"
                                    value={this.blockHelper.getFunctionNameById(parseInt(params.callNext), functions)}
                                />
                            )}
                            {params.status && typeof params.status === 'string' && <StatusElement name="setStatus" value={params.status} />}
                            {params.callOnError && (
                                <ErrorElement name={this.blockHelper.getFunctionNameById(parseInt(params.callOnError), functions)} />
                            )}
                            {!params.callOnError && <ErrorElement name={this.blockHelper.getFunctionNameById(7, functions)} />}
                        </TableBody>
                    </Table>
                </CardBody>
            </Card>
        );
    }
}

export default compose<any, any>(withStyles(adescomStyle))(DefaultView);
